import req from "@/assets/js/axios"

export default {
    // 学校查询比赛列表
    getCompetitionsBySchool: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/getCompetitionsBySchool', params)
    },
     // 前台查询已审核通过比赛
     getCompetitions: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/getCompetitions', params)
    },
    // 学校提交比赛申请
    saveOrSubmitCompetition: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/saveOrSubmitCompetition', params)
    },
    // 学校撤回比赛申请
    withdraw: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/withdraw', params)
    },
    // 比赛举办方查询评委列表
    getJudgesByCompetition: (params) => {
        return req.apiAxios('POST', '/judge/judgeController/whale-security/getJudgesByCompetition', params)
    },
    // 学校新增评委
    createJudgeBySchool: (params) => {
        return req.apiAxios('POST', '/judge/judgeController/whale-security/createJudgeBySchool', params)
    },
    // 学校移除评委
    removeJudgeBySchool: (params) => {
        return req.apiAxios('POST', '/judge/judgeController/whale-security/removeJudgeBySchool', params)
    },
    // 作品分配评委
    allotJudge: (params) => {
        return req.apiAxios('POST', '/judgeOpus/judgeOpusController/whale-security/allotJudge', params)
    },
    // 设置评分标准（审核通过后）
    settingsScoreStandard: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/settingsScoreStandard', params)
    },
    //学校更新比赛状态（审核通过后）
    updateCompetitionStatusBySchool: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/updateCompetitionStatusBySchool', params)
    },
    //查询参赛作品列表
    getOpusByCompetition: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/getOpusByCompetition', params)
    },
    //审核参赛学校展会
    approvalSchoolExhibitionApply: (params) => {
        return req.apiAxios('POST', '/competition/competitionController/whale-security/approvalSchoolExhibitionApply', params)
    },
    // 评委查询自己参评的比赛
    getCompetitionsByJudge: (params) => {
        return req.apiAxios('POST', '/judge/judgeController/whale-security/getCompetitionsByJudge', params)
    },
    // 评委查询已分配作品
    getJudgeAllotOpuses: (params) => {
        return req.apiAxios('POST', '/judgeOpus/judgeOpusController/whale-security/getJudgeAllotOpuses', params)
    },
    // 查询作品已分配评委
    getOpusAllotJudges: (params) => {
        return req.apiAxios('POST', '/judgeOpus/judgeOpusController/whale-security/getOpusAllotJudges', params)
    },
    // 评委提交比赛评分
    submitMark: (params) => {
        return req.apiAxios('POST', '/judgeOpus/judgeOpusController/whale-security/submitMark', params)
    },
    // 评委评分作品
    judegeMark: (params) => {
        return req.apiAxios('POST', '/judgeOpus/judgeOpusController/whale-security/mark', params)
    },
}
